import CustomStyle from "./custom-style.js";
class EmptyCustomStyle extends CustomStyle {
  constructor() {
    super("empty", {});
  }
  overrideWith(customStyle) {
    return customStyle;
  }
}
export {
  EmptyCustomStyle as default
};
//# sourceMappingURL=empty-custom-style.js.map
